import React, {Component} from 'react';

import imgPoliceBadge from '../img/police-badge.png';
import imgTananAssistantQrCode from '../img/tanan-assistant-qr.png';

import 'lightbox2/dist/css/lightbox.css';
import './Footer2017.css';

window.jQuery = window.$ = require('zeptojs');
require('lightbox2/dist/js/lightbox');

export default class Footer2017 extends Component {

  render() {
    return (
      <footer>
        <div className="container-fluid footer">{/* Need footer to indicate footer area. */}
          <div className="row">
          <div className="container">
            <div className="row">
              <div className="col-xs-12 col-sm-7">
                <h4>关于我们</h4>
                <p>从桌面应用到移动设备，从规划开发到上线运维，坦安信息提供全面的咨询服务和技术支持。</p>
                <p>为开发商、开发者提供覆盖信息系统完整生命周期所需要的技术咨询及培训，介绍及展示最精华、最实用的开发知识和技巧，帮助开发团队或个人在最短的时间内获得最需要的开发技能及知识。</p>
                <div className="license">
                  <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer">沪ICP备17057251号-1</a>
                </div>
                <div className="license">
                  <img src={imgPoliceBadge} alt="公安部网络安全备案标志"/>
                  <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502007176" target="_blank" rel="noopener noreferrer">
                    沪公网安备 31011502007176号</a>
                </div>
              </div>
              <div className="col-xs-12 col-sm-5">
                <h4>联系我们</h4>
                <div className="row">
                  <div className="col-xs-6">
                    <div>
                      <a data-lightbox="imgTananAssistantQrCode" href={imgTananAssistantQrCode}><img className="wechat-qr" src={imgTananAssistantQrCode} alt="坦安助手二维码"/></a>
                    </div>
                    <h5>坦安助手</h5>
                  </div>
                  <div className="col-xs-6">
                    <strong>电子邮件</strong>
                    <p>postmaster at tanan.net.cn</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>
        </div>
        <div className="container-fluid copyright-bottom">
          © 2017 - 2023 坦安信息
        </div>
      </footer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Footer2017.js